import React from 'react'
import { InputLabel, MenuItem, Select } from '@material-ui/core/'
import { Translation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
// import { employerSide } from '../routerHistory'

const styles = () => ({
  select: {
    lineHeight: '1.5',
    fontSize: '14px',
    outline: 'none',
    // marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
    // borderRadius:'1rem'
  }
})

const DropDownPagination = ({
  classes,
  paginationRowValue,
  changePagination
}) => (
  <Translation>
    {(t) => {
      return (
        <div
          style={{
            // display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '20px 20px 0px 0px'
          }}
        >
          <InputLabel
            shrink
            style={{
              marginTop: '-8px',
              fontSize: '20px',
              fontWeight: 500,
              color: 'black'
            }}
          >
            {/* {employerSide
              ? t('employer.lightEntrepreneurs.label3')
              : t('assignment.label9')} */}
            {t('asiakkaat.show')}
          </InputLabel>
          <Select
            labelId="demo-controlled-open-select-label"
            id="demo-controlled-open-select"
            className={classes.select}
            disableUnderline={true}
            value={paginationRowValue}
            onChange={changePagination}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </div>
      )
    }}
  </Translation>
)

export default withStyles(styles)(DropDownPagination)
